import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from 'src/shared/routes';

import { Loading } from 'src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'admin-comms-orders-results',
		path: '/admin/comms/send_orders/:id/results',
		component: loadable(async () => import(/* webpackChunkName: "pages/admin_comms_orders_results" */ './index'), {
			exportName: 'AdminCommsOrdersResults',
			fallback: Loading,
		}),
		restrictedAccess: {
			authOnly: true,
			role: ['staff'],
		},
		frame: true,
		ssr: {
			enabled: false,
			seo: false,
		},
	},
];
